export const transformArrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  // Преобразуем ArrayBuffer в Uint8Array
  const bytes = new Uint8Array(buffer);

  // Преобразуем байты в строку
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  // Кодируем строку в base64
  return btoa(binary);
};
